import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom"; // Updated for React App

export default function Services() {
  const b2bServices = [
    {
      title: "Product Sales & Procurement",
      desc: "Your single source for high-quality IT hardware. We provide a leading range of enterprise servers, high-performance desktops, and advanced security hardware from global brands.",
      image: "https://ik.imagekit.io/igxrggga8/pcworldraipur.in/Banners%20frontsite/Professional%20IT%20System%20Services.png",
      tag: "Hardware Sales",
      features: ["Enterprise Servers", "Corporate Workstations", "Genuine Software Licensing"]
    },
    {
      title: "Professional IT Systems",
      desc: "Expert deployment and optimization of your digital workspace. From LAN/WAN architecture to cloud integration, we ensure your infrastructure is scalable and secure.",
      image: "https://images.unsplash.com/photo-1551739440-5dd934d3a94a?q=80&w=800",
      tag: "Integration",
      features: ["Network Architecture", "Cloud Migration", "Firewall Configuration"]
    },
    {
      title: "Maintenance & AMC Support",
      desc: "Proactive support to guarantee maximum uptime. Our Annual Maintenance Contracts (AMC) offer peace of mind with on-demand hardware repair and routine system health checks.",
      image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?q=80&w=800",
      tag: "Support",
      features: ["24/7 Priority Assistance", "On-site Preventive Care", "Hardware Life-cycle Management"]
    }
  ];

  return (
    <div className="w-full bg-white selection:bg-blue-600 selection:text-white font-sans overflow-x-hidden">
      
      {/* 1. HEADER SECTION */}
      <section className="pt-12 pb-16 lg:pt-20 lg:pb-24 px-6 bg-slate-50 border-b border-slate-100">
        <div className="max-w-7xl mx-auto text-center">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl lg:text-7xl font-extrabold text-slate-900 tracking-tight mb-4"
          >
            Services We Are Offering
          </motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
            className="text-xl lg:text-2xl text-blue-600 font-bold uppercase tracking-widest"
          >
            Our Core B2B IT Solutions
          </motion.p>
        </div>
      </section>

      {/* 2. SERVICES GRID */}
      <section className="py-24 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-3 gap-10">
            {b2bServices.map((service, i) => (
              <motion.div 
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="bg-white rounded-[2rem] border border-slate-200 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden"
              >
                <div className="h-64 overflow-hidden">
                  <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-500"
                  />
                </div>

                <div className="p-10">
                  <div className="inline-block px-3 py-1 rounded-md bg-blue-50 text-blue-600 text-[10px] font-black uppercase tracking-widest mb-4">
                    {service.tag}
                  </div>
                  <h3 className="text-2xl font-extrabold text-slate-900 mb-4">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 text-base leading-relaxed mb-8">
                    {service.desc}
                  </p>
                  
                  <div className="space-y-3 mb-10">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-3 text-sm font-bold text-slate-800">
                        <span className="w-1.5 h-1.5 rounded-full bg-blue-600"></span>
                        {feature}
                      </div>
                    ))}
                  </div>

                  <Link 
                    to="/contact" 
                    className="block text-center bg-slate-900 text-white py-4 rounded-xl font-bold uppercase text-xs tracking-widest hover:bg-blue-600 transition-colors"
                  >
                    Request Consultation
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* 3. B2B ACTION BLOCK */}
      <section className="pb-24 px-6">
        <div className="max-w-7xl mx-auto bg-slate-900 rounded-[3rem] p-12 lg:p-20 text-center text-white">
          <h2 className="text-3xl lg:text-5xl font-extrabold mb-6 tracking-tight">
            Need a Customized B2B Quote?
          </h2>
          <p className="text-slate-400 text-lg mb-10 max-w-2xl mx-auto">
            From bulk hardware procurement to complex network deployment, our team is ready to assist your organization.
          </p>
          <Link 
            to="/contact" 
            className="bg-blue-600 text-white px-12 py-5 rounded-full font-bold text-lg hover:bg-white hover:text-blue-600 transition-all shadow-xl inline-block"
          >
            Get a Quote Now
          </Link>
        </div>
      </section>

    </div>
  );
}